import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {COLOR_CODE} from '@/utils/constants/colors';
import './_pageContainer.scss';
const PageContainer = ({
  children,
  background = COLOR_CODE._1D1D1D,
  borderRadius = '8px',
  height = '100%',
  minHeight,
  ...rest
}) => {
  const containerStyle = useMemo(
    () => ({
      '--dynamic-background': background,
      '--dynamic-border-radius': borderRadius,
      '--dynamic-height': height,
      '--dynamic-min-height': minHeight
    }),
    [background, borderRadius, height, minHeight]
  );

  return (
    <div className={'pc-container-position flex flex-col text-base'}>
      <div
        style={containerStyle}
        className={
          'shadow pc-block mb-3 mt-4 flex w-full flex-col  p-6 text-white'
        }
        data-cy='page-content'
        {...rest}>
        {children}
      </div>
    </div>
  );
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.string,
  borderRadius: PropTypes.string,
  height: PropTypes.string,
  minHeight: PropTypes.string
};

export default React.memo(PageContainer);
